module.exports = __webpack_public_path__ + "assets/img/vn.023ba3db.png";